/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientTicketDto } from '../../models/client-ticket-dto';

export interface ClientTicketControllerFindById$Params {
  id: string;
}

export function clientTicketControllerFindById(http: HttpClient, rootUrl: string, params: ClientTicketControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientTicketDto>> {
  const rb = new RequestBuilder(rootUrl, clientTicketControllerFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientTicketDto>;
    })
  );
}

clientTicketControllerFindById.PATH = '/api/client-ticket/{id}';
